

export default {
  name: 'MyAdItemTrailerChips',
  props: {
    item: {
      default: () => Object,
      type: Object
    },
    showEmptyChips: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      color: 'grey lighten-4',
      clazz: 'mt-1'
    }
  },
  methods: {
    exists (attributeCode, backendType, attributes) {
      return attributes[backendType + 's'].find(attribute => attribute.attributeCode === attributeCode)
    },

    showChip (attributeCode, backendType) {
      if (this.showEmptyChips) {
        return true
      }

      if (this.format(attributeCode, backendType) === undefined ||
        this.format(attributeCode, backendType) === '-' ||
        this.format(attributeCode, backendType) === 'attributes.' + attributeCode
      ) {
        return false
      }
      return true
    },

    format (attributeCode, backendType) {
      if (attributeCode === 'trailer_hu_valid_through') {
        const huExpired = this.item.attributes.selects.find(attribute => attribute.attributeCode === 'trailer_hu_expired')
        if (huExpired && huExpired.value?.label?.toLowerCase() === 'ja') {
          return this.$i18n.t('attributes.trailer_hu_expired')
        }
      }

      return this.$eavFormatter.findAndFormatAndLabelAttribute(attributeCode, backendType, this.item.attributes)
    }
  }
}
